// src/Components/announcements/AnnouncementDetailEditMode.js
import React from "react";
import AttachmentsPanel from "../AttachmentPanel";
import AiAnnouncementAssistant from "../AiAnnouncementAssistant";
import styles from "../../Styles/Announcementnew2.module.css";

const CATEGORY_OPTIONS = [
  "Tapahtumat ja tilaisuudet",
  "Ylläpito ja huolto",
  "Tiedotukset ja uutiset",
  "Yhtiökokoukset",
  "Taloustiedotteet",
  "Säännöt ja ohjeet",
  "Turvallisuus",
  "Muut",
];

function AnnouncementDetailEditMode({
  safeDraft,
  isBusy,
  announcementId,
  setDraftField,
  handleUploadFiles,
  handleDeleteAttachment,
}) {
  return (
    <>
      <h3 className={styles.sectionTitle}>Luokittelu</h3>

      <div className={styles.formRow}>
        <label className={styles.label}>Otsikko</label>
        <div className={styles.titleInputRow}>
          <input
            className={styles.input}
            style={{ flex: "1 1 auto", minWidth: "0" }}
            value={safeDraft.title}
            onChange={(e) => setDraftField("title", e.target.value)}
            placeholder="Esim. Leikkipihan talkoot la 10.6."
            disabled={isBusy}
          />

          <div className={styles.aiButtonWrap}>
            <AiAnnouncementAssistant
              onGenerated={(gen) => {
                if (gen.title) setDraftField("title", gen.title);
                if (gen.content) setDraftField("content", gen.content);
                if (gen.category) setDraftField("category", gen.category);
                if (gen.audience) setDraftField("audience", gen.audience);
              }}
            />
          </div>
        </div>
      </div>

      <div className={styles.formRowGrid}>
        <div className={styles.formCol}>
          <label className={styles.label}>Kategoria</label>
          <select
            className={styles.input}
            value={safeDraft.category}
            onChange={(e) => setDraftField("category", e.target.value)}
            disabled={isBusy}
          >
            <option value="">Valitse…</option>
            {CATEGORY_OPTIONS.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.formCol}>
          <label className={styles.label}>Kohderyhmä</label>
          <select
            className={styles.input}
            value={safeDraft.audience}
            onChange={(e) => setDraftField("audience", e.target.value)}
            disabled={isBusy}
          >
            <option value="owners">Osakkaat</option>
            <option value="residents_owners">Asukkaat ja osakkaat</option>
          </select>
        </div>
      </div>

      <h3 className={styles.sectionTitle}>Kuvaus</h3>
      <div className={styles.formRow}>
        <textarea
          className={`${styles.input} ${styles.inputArea}`}
          rows={10}
          value={safeDraft.content}
          onChange={(e) => setDraftField("content", e.target.value)}
          placeholder="Kirjoita tiedotteen sisältö…"
          disabled={isBusy}
        />
      </div>

      <h3 className={styles.sectionTitle}>Dokumentit</h3>
      <div className={styles.formRow}>
        <AttachmentsPanel
          attachments={safeDraft.attachments || []}
          onUpload={handleUploadFiles}
          onDelete={handleDeleteAttachment}
          disabled={isBusy}
          resetKey={announcementId || "new"}
        />
      </div>
    </>
  );
}

export default AnnouncementDetailEditMode;